import { UserFeedbackUploadFileContext } from '@/App'
import { Button, message } from 'antd'
import { RcFile } from 'antd/lib/upload'
import { useCallback, useContext, useEffect, useState } from 'react'
import './index.less'
import UserFeedbackUploadFilePanelItem from './upload-item'
import { Modal } from 'bimui'

export interface UserFeedbacUploadFileLocale {
    file: RcFile,
    callbackFn: (param: UserFeedbackFileUploadParam) => Promise<any>
}

export interface UserFeedbackUploadFileState {
    files: UserFeedbacUploadFileLocale[]
    visible: boolean
    startUpload: (files: UserFeedbacUploadFileLocale[]) => void
    onEnd: (value: number) => void
    count: number // 用于记录上传了多少个文件
}

export interface UserFeedbackFileUploadParam {

    md5: string,
    suffix: string,
    filePath: string,
    name: string,
    type?: number,
    replaceId?: number,
    parentId?: number,
    fileSize: number,

}

export const useFeedbackUploadService = () => {
    const [files, setFiles] = useState<UserFeedbacUploadFileLocale[]>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const startUpload = useCallback((uploadFiles: UserFeedbacUploadFileLocale[]) => {
        setCount(0);
        setFiles(uploadFiles)
    }, [])

    const onEnd = useCallback((value: number) => {
        setCount(value);
        setVisible(false)
    }, [])

    useEffect(() => {
        if (files.length > 0) {
            setVisible(true);
        }
    }, [files])

    return {
        files,
        visible,
        startUpload,
        onEnd,
        count,
    } as UserFeedbackUploadFileState
}

export default function UserFeedbackUploadPanel(props) {
    const uploadContext = useContext<UserFeedbackUploadFileState>(UserFeedbackUploadFileContext);
    const [files, setFiles] = useState<UserFeedbacUploadFileLocale[]>([]);
    const [uploadCounter, setUploadCounter] = useState(0);
    const [stopSignal, setStopSignal] = useState(false);

    useEffect(() => {
        if (uploadContext.visible) {
            setStopSignal(false)
            start();
        }
    }, [uploadContext.visible])

    useEffect(() => {
        if (uploadCounter && uploadCounter === files.length) {
            onClose();
        }
    }, [uploadCounter])

    const start = () => {
        let files = uploadContext.files;
        if (files == null || files.length === 0) {
            message.warning('没有要上传的文件，上传被取消');
            onClose();
            return;
        }
        setFiles([...files]);
    }

    const onClose = (time = 500) => {
        setTimeout(() => {
            setFiles([]);
            uploadContext.onEnd(uploadCounter);
            setUploadCounter(0);
        }, time)
    }

    const stop = () => {
        setStopSignal(true)
        onClose(0);
    }

    return (
        <Modal
            open={uploadContext.visible}
            mask
            showHeader={false}
            showFooter={false}
        >
            <div className="upload-panel-container">
                <div className='scrollable'>
                    {files.map(item => (
                        <UserFeedbackUploadFilePanelItem
                            onComplete={() => setUploadCounter(pre => pre + 1)}
                            key={item.file.uid}
                            file={item.file}
                            stopSignal={stopSignal}
                            callbackFn={item.callbackFn} />
                    ))}
                </div>

                <div className="footer">
                    <Button danger size="small" onClick={stop}>取消上传</Button>
                </div>
            </div>
        </Modal>
    )
}